module.exports = __webpack_public_path__ + "static/media/logo_white.963a7792.svg";